import React from 'react';
// Admin mascot preview page — wraps DjayShowcase for admin portal routing
// DDD: imports from mascot barrel (moved from components/mascot/ in s70)
export { DjayShowcase as MascotPage } from '../../../mascot';